export const SUBMIT = 'SUBMIT';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_ERROR = 'SUBMIT_ERROR';
export const TOGGLE_CHECKBOX = 'TOGGLE_CHECKBOX';
export const SET_INPUT_VALUE = 'SET_INPUT_VALUE';
